import GetWithProgress from "partners/utils/get_with_progress"

import { put } from "shared/lib/api"

export default function AdminActions() {
  const showAdminForm = () => {
    document.querySelector(".admin-new").style.display = "block"
    document.querySelector(".add-admin button").style.display = "none"
  }

  const hideAdminForm = e => {
    document.querySelector(".admins li").style.display = "block"
    document.querySelector(".admin-new").style.display = "none"
    document.querySelector(".add-admin button").style.display = "block"

    let el = e.currentTarget
    if (!el.classList.contains("loading")) {
      el.classList.add("loading")
      GetWithProgress(el.dataset.href).finally(() => el.classList.remove("loading"))
    }
  }

  document.querySelector(".add-admin button")?.addEventListener("click", showAdminForm)
  document.querySelector(".admins li button[data-load-form-async]")?.addEventListener("click", hideAdminForm)

  const adminFormManagement = event => {
    switch (event.target.dataset["action"]) {
      case "cancel-new":
        event.preventDefault()
        document.querySelector(".admin-new").style.display = "none"
        document.querySelector(".add-admin button").style.display = "block"
        break
      case "cancel-update":
      case "add-admin":
        event.preventDefault()
        document.querySelector(".admin-update-parent, .admin-update")?.remove()
        document.querySelector(".admins li").style.display = "block"
    }
  }
  document.querySelector(".admins-edit").addEventListener("click", adminFormManagement)

  const updateOrCreateAdmin = event => {
    event.preventDefault()

    const extractValuesFor = inputName =>
      event.target.querySelector(`[name='partners_channel_admin[${inputName}]']`).value

    put(event.target.getAttribute("action"), {
      partners_channel_admin: {
        email: extractValuesFor("email"),
        name: extractValuesFor("name"),
        phone: extractValuesFor("phone"),
      },
    }).finally(() => {
      const button = event.target.querySelector("[type=submit]")
      button.value = button.dataset["action"] == "add-admin" ? "Save" : "Update"
      button.removeAttribute("disabled")
    })
  }
  document.querySelector(".admins-edit").addEventListener("submit", updateOrCreateAdmin)

  if (document.querySelector(".admin-new")?.style.display === "block") {
    document.querySelector(".add-admin button").style.display = "none"
  }
}
